import React from 'react'

const AdvertSpace = () => {
  return (
    <div>
        <div className="text-center">
           <p className="font-light text-gray-700">Advert space</p>
        </div>
    </div>
  )
}

export default AdvertSpace